import type { PrototypeCatalogEntity } from "../../entity_types/catalog";

export const catalog_abbott_brand_page_deep_dive: PrototypeCatalogEntity = {
  token: "catalog_abbott_brand_page_deep_dive",
  type: "catalog",
  name: "Abbott Brand Page Deep Dive Catalog",
  brandToken: "catalog_brand_abbott",
  collectionTokens: [],
  categoryTokens: [],
  productTokens: [
    "legacy_prod_abbott-1",
    "legacy_prod_abbott-2",
    "legacy_prod_abbott-3",
    "legacy_prod_abbott-4",
    "legacy_prod_abbott-5",
    "legacy_prod_abbott-6",
    "legacy_prod_abbott-7",
    "legacy_prod_abbott-8",
    "legacy_prod_abbott-9",
    "legacy_prod_abbott-10",
    "legacy_prod_abbott-11",
    "legacy_prod_abbott-12",
    "legacy_prod_abbott-13",
    "legacy_prod_abbott-14",
    "legacy_prod_abbott-15",
    "legacy_prod_abbott-16",
    "legacy_prod_abbott-17",
    "legacy_prod_abbott-18",
    "legacy_prod_abbott-19",
    "legacy_prod_abbott-20",
    "legacy_prod_abbott-21",
    "legacy_prod_abbott-22",
    "legacy_prod_abbott-23",
    "legacy_prod_abbott-24",
    "legacy_prod_abbott-25",
    "legacy_prod_abbott-26",
    "legacy_prod_abbott-27",
    "legacy_prod_abbott-28",
    "legacy_prod_abbott-29",
    "legacy_prod_abbott-30",
    "legacy_prod_abbott-31",
    "legacy_prod_abbott-32",
    "legacy_prod_abbott-33",
    "legacy_prod_abbott-34",
    "legacy_prod_abbott-35",
    "legacy_prod_abbott-36",
    "legacy_prod_abbott-37",
    "legacy_prod_abbott-38",
    "legacy_prod_abbott-39",
    "legacy_prod_abbott-40",
    "legacy_prod_abbott-41",
    "legacy_prod_abbott-42",
    "legacy_prod_abbott-43",
    "legacy_prod_abbott-44",
    "legacy_prod_abbott-45",
    "legacy_prod_abbott-46",
    "legacy_prod_abbott-47",
    "legacy_prod_abbott-48",
    "legacy_prod_abbott-49",
    "legacy_prod_abbott-50",
    "legacy_prod_abbott-51",
    "legacy_prod_abbott-52",
    "legacy_prod_abbott-53",
    "legacy_prod_abbott-54",
    "legacy_prod_abbott-55",
    "legacy_prod_abbott-56",
    "legacy_prod_abbott-57",
    "legacy_prod_abbott-58",
    "legacy_prod_abbott-59",
    "legacy_prod_abbott-60",
    "legacy_prod_abbott-61",
    "legacy_prod_abbott-62",
    "legacy_prod_abbott-63",
    "legacy_prod_abbott-64",
    "legacy_prod_abbott-65",
    "legacy_prod_abbott-66",
    "legacy_prod_abbott-67",
    "legacy_prod_abbott-68",
    "legacy_prod_abbott-69",
    "legacy_prod_abbott-70",
    "legacy_prod_abbott-71",
    "legacy_prod_abbott-72",
    "legacy_prod_abbott-73",
    "legacy_prod_abbott-74",
    "legacy_prod_abbott-75",
    "legacy_prod_abbott-76",
    "legacy_prod_abbott-77",
    "legacy_prod_abbott-78",
    "legacy_prod_abbott-79",
    "legacy_prod_abbott-80",
    "legacy_prod_abbott-81",
    "legacy_prod_abbott-82",
    "legacy_prod_abbott-83",
    "legacy_prod_abbott-84",
    "legacy_prod_abbott-85",
    "legacy_prod_abbott-86",
    "legacy_prod_abbott-87",
    "legacy_prod_abbott-88",
    "legacy_prod_abbott-89",
    "legacy_prod_abbott-90",
    "legacy_prod_abbott-91",
    "legacy_prod_abbott-92",
    "legacy_prod_abbott-93",
    "legacy_prod_abbott-94",
    "legacy_prod_abbott-95",
    "legacy_prod_abbott-96",
    "legacy_prod_abbott-97",
    "legacy_prod_abbott-98",
    "legacy_prod_abbott-99",
    "legacy_prod_abbott-100",
    "legacy_prod_abbott-101",
    "legacy_prod_abbott-102",
    "legacy_prod_abbott-103",
    "legacy_prod_abbott-104",
    "legacy_prod_abbott-105",
    "legacy_prod_abbott-106",
    "legacy_prod_abbott-107",
    "legacy_prod_abbott-108",
    "legacy_prod_abbott-109",
    "legacy_prod_abbott-110",
    "legacy_prod_abbott-111",
    "legacy_prod_abbott-112",
    "legacy_prod_abbott-113",
    "legacy_prod_abbott-114",
    "legacy_prod_abbott-115",
    "legacy_prod_abbott-116",
    "legacy_prod_abbott-117",
    "legacy_prod_abbott-118",
    "legacy_prod_abbott-119",
    "legacy_prod_abbott-120",
    "legacy_prod_abbott-121",
    "legacy_prod_abbott-122",
    "legacy_prod_abbott-123",
    "legacy_prod_abbott-124",
    "legacy_prod_abbott-125",
    "legacy_prod_abbott-126",
    "legacy_prod_abbott-127",
    "legacy_prod_abbott-128",
    "legacy_prod_abbott-129",
    "legacy_prod_abbott-130",
    "legacy_prod_abbott-131",
    "legacy_prod_abbott-132",
    "legacy_prod_abbott-133",
    "legacy_prod_abbott-134",
    "legacy_prod_abbott-135",
    "legacy_prod_abbott-136",
    "legacy_prod_abbott-137",
    "legacy_prod_abbott-138",
    "legacy_prod_abbott-139",
    "legacy_prod_abbott-140",
    "legacy_prod_abbott-141",
    "legacy_prod_abbott-142",
    "legacy_prod_abbott-143",
    "legacy_prod_abbott-144",
    "legacy_prod_abbott-145",
    "legacy_prod_abbott-146",
    "legacy_prod_abbott-147",
    "legacy_prod_abbott-148",
    "legacy_prod_abbott-149",
    "legacy_prod_abbott-150",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
